import { render, staticRenderFns } from "./OrderReportDetails.vue?vue&type=template&id=293c54ee&scoped=true&"
import script from "./OrderReportDetails.vue?vue&type=script&lang=ts&"
export * from "./OrderReportDetails.vue?vue&type=script&lang=ts&"
import style0 from "./OrderReportDetails.vue?vue&type=style&index=0&id=293c54ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293c54ee",
  null
  
)

export default component.exports